import Vue from 'vue';
import VuexPersistance from 'vuex-persist';
import Vuex from 'vuex';
import general from './modules/general';
import user from './modules/user';
import auth from './modules/auth';
import favorites from './modules/favorites';

const vuexLocal = new VuexPersistance({
	storage: window.localStorage
});

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
	modules : {
		general,
		auth,
		user,
		favorites
	},
	strict : debug,
	plugins : [vuexLocal.plugin ]
});


// WEBPACK FOOTER //
// ./src/utils/store/index.js